import { SearchResult as SearchResultType } from '../../types';
import { RefObject } from 'preact';
import './search-result.css';

interface SearchResultProps {
  result: SearchResultType;
  isSelected: boolean;
  ref?: RefObject<HTMLAnchorElement>;
}

export function SearchResult({ result, isSelected, ref }: SearchResultProps) {
  return (
    <a
      href={result.url}
      class={`search-result ${isSelected ? 'selected' : ''}`}
      ref={ref}
    >
      {result.thumbnail && (
        <img
          src={result.thumbnail}
          alt={result.title}
          class="result-thumbnail"
        />
      )}
      <div class="result-content">
        <p class="result-title">{result.title}</p>
        {result.author && (
          <p class="result-author">
            <em>by {result.author.name || result.author.username}</em>
          </p>
        )}
        <p class="result-type">{result.type}</p>
      </div>
    </a>
  );
}
